import { Typography } from '@kizen/kds/Typography';
import { TFunction } from 'react-i18next';
import BasicModal from '__components/Modals/presets/BasicModal';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { hidePaymentMessage } from 'store/authentication/authenticationAction';
import { useBillingPermissions } from 'ts-components/hooks/permissions/billing';
import { openUrlOnClick } from 'components/Inputs/helpers';

const getLimitSpecificMessage = (
  category: string,
  type: string,
  t: TFunction
) => {
  switch (category) {
    case 'custom_objects': {
      switch (type) {
        case 'record_count':
          return t(
            'This custom object has reached the maximum number of records.'
          );
        case 'field_count':
          return t(
            'This custom object has reached the maximum number of fields.'
          );
      }
      return '';
    }
    case 'users': {
      switch (type) {
        case 'user_count':
          return t('You have reached the maximum number of users.');
      }
      return '';
    }
    case 'email': {
      switch (type) {
        case 'email_count':
          return t(
            'You have reached the maximum number of emails for the current billing cycle.'
          );
      }
      return '';
    }
    case 'automations': {
      switch (type) {
        case 'automation_step_count':
          return t(
            'No agentic workflow execution credits remain for the current billing cycle.'
          );
      }
      return '';
    }
  }
};

export const PaymentNeededHandler = () => {
  const authentication = useSelector(({ authentication }) => authentication);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { isShowPaymentMessage, paymentMessagePayload = {} } = authentication;

  const { canManagePlans } = useBillingPermissions();

  if (!isShowPaymentMessage) {
    return null;
  }

  const { billing_error_type, billing_error_category } = paymentMessagePayload;

  const message =
    getLimitSpecificMessage(billing_error_category, billing_error_type, t) ||
    t('An account limit has been reached.');

  return (
    <>
      <BasicModal
        show
        buttonText={canManagePlans ? t('Upgrade') : t('Close')}
        heading={t('Account Limit Reached')}
        onHide={() => {
          dispatch(hidePaymentMessage());
        }}
        onConfirm={() => {
          dispatch(hidePaymentMessage());

          if (!canManagePlans) {
            return;
          }
          openUrlOnClick('/settings/billing/usage');
        }}
        leftBtn={!canManagePlans ? null : undefined}
      >
        <div className="py-2">
          <Typography className="text-center">
            {message}{' '}
            {!canManagePlans
              ? t('Please contact your administrator to upgrade your account.')
              : t('Please upgrade your account before continuing.')}
          </Typography>
        </div>
      </BasicModal>
    </>
  );
};
